/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bulb': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M7.5 19.167h1.67V20h1.66v-.833h1.67V17.5h-5v1.667zm2.5-15a5.831 5.831 0 00-2.5 11.1v.568a.831.831 0 00.83.833h3.34a.831.831 0 00.83-.833v-.569A5.831 5.831 0 0010 4.167zm1.39 9.757a.841.841 0 00-.56.785V15H9.17v-.29a.841.841 0 00-.56-.785 4.17 4.17 0 112.78-.001zM10.83 0H9.17v3.333h1.66V0zM0 10.833h3.33V9.167H0v1.667zm16.67-1.667v1.667H20V9.167h-3.33zm1.42-6.078L16.91 1.91l-2.5 2.5 1.18 1.178zM5.59 4.41l-2.5-2.5-1.18 1.178 2.5 2.5z" _fill="#15161a" fill-rule="evenodd"/>'
  }
})
